import { Component, OnInit } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { AppConfig } from '../../../app/app.config';

@Component({
  selector: 'app-choice',
  templateUrl: './remove-comment.component.html',
})

export class RemoveCommentComponent implements OnInit {
  config = AppConfig.settings;
  comment: string;
  message: string;
  trueText: string = 'Yes';
  falseText: string = 'No';

  constructor(
    params: NavParams,
    public viewController: ViewController,
  ) {
    this.message = params.get('message');

    this.comment = params.get('comment');

    const trueText = params.get('trueText');

    if (!!trueText) {
      this.trueText = trueText;
    }

    const falseText = params.get('falseText');

    if (!!falseText) {
      this.falseText = falseText;
    }
  }

  ngOnInit() {

  }

  closeModal(choice: boolean) {
    this.viewController.dismiss({choice: choice});
  }
}



// WEBPACK FOOTER //
// ./src/pages/operations/remove-comment/remove-comment.component.ts